import Lottie from "lottie-react";
import about from "../images/about.json";
import team from "../images/team.jpg";
import Aos from "aos";
import { useEffect } from "react";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
const About = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <div
      data-aos="fade-up"
      className="min-h-[550px] flex relative overflow-hidden md:rounded-3xl mt-10 bg-slate-200 lg:px-0 md:px-12 md:py-12 p-12"
    >
      <div className="flex min-h-full justify-around items-center w-full md:flex-col lg:flex-row flex-col">
        <div>
          {/* <Lottie className="max-w-[500px]" animationData={about} /> */}
          <img
            className="sm:max-w-[500px] max-w-[320px] rounded-lg"
            src={team}
            alt=""
          />
        </div>
        <div className="max-w-[500px] md:mt-2 mt-2">
          <h1 className="font-semibold sm:text-2xl text-xl text-[#FE4904]">
            About our Team
          </h1>
          <h2 className="font-bold sm:text-5xl text-2xl sm:my-4 my-2">
            A Full Service Design and Branding Agency
          </h2>
          <p className="text-gray-400 sm:text-lg text-sm">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Expedita
            porro facilis, harum itaque nam placeat.
          </p>
          <Link to="/about">
            <button className="bg-gradient-to-r mt-2 from-[#FE4904] to-[#F7164C] sm:px-10 sm:py-5 px-4 py-2 rounded-xl  hover:from-[#F7164C] hover:to-[#FE4904] text-white transition ease-in-out text-lg ">
              Read More
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};
export default About;
